export default function doesNotContain() {
    return function (arr, input) {
        if (arr) {
            return arr.indexOf(input) !== -1 ? false : true;
        }

        return true;
    };
}
